// removed by extract-text-webpack-plugin
module.exports = {"horizontalScrollWrapper":"G705940"};